import { AccountDataController } from './account-data.controller';

export const AccountDataComponent: ng.IComponentOptions = {
    template: require('./account-data.html'),
    controller: AccountDataController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/account-data/account-data.component.ts